import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';

@Injectable({
  providedIn: 'root'
})
export class ReportDeliverService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  findActaEntrega(cedula: string, fecha: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.report.url + 
        this.diccionarioUrl.report.actaEntrega + '/' + cedula + '/' + (fecha == ' ' ? this.utilServices.getFechaGuion() : fecha));
  }

  findHistory(cedula: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.report.url + '/history/' + cedula);
  }

  generateReport(tipo: string, fechaIni: string, fechaFin: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.report.url + '/' + tipo + '/' + fechaIni + '/' + fechaFin);
  }

}